/**
 * Logo 下方轮动文案：地道中文，突出安全与专业。
 * 登录页、落地页等共用，改一处即可全局一致。
 */
export const WELCOME_TAGLINES = [
  "安全可控的多智能体协作，任务全程可审计",
  "安全编排 AI 工作流，复杂流程有据可循",
  "全链路安全留痕，会话与工具调用合规可查",
  "安全隔离 · 权限可控 · 多 Agent 协同执行",
  "为团队而生：安全、可控、可追溯、可落地",
] as const

export const WELCOME_TAGLINE_INTERVAL_MS = 4500

/**
 * 对话页空状态：专业、克制，突出安全可控与可预期（避免口语化、避免堆砌「留痕」等词）
 */
export const CHAT_EMPTY_GUIDES = [
  "在输入框简要说明任务背景与期望产出，系统将在既定权限与流程内编排多 Agent 执行。",
  "描述目标与约束即可；执行过程可追溯，关键步骤与工具调用均有记录可供审计。",
  "企业级编排已就绪。输入任务后，各 Agent 按角色分工协同，结果可复盘、可交付。",
] as const
